import { inject, Injectable }                                                                 from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { Observable }                                                                         from 'rxjs';

import { SessionService, UserSession } from '../../api/session/session.service';
import { AuthenticationService }       from '../../core/auth/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureSwitchGuard implements CanActivate, CanActivateChild {
  private auth = inject(AuthenticationService);
  private router = inject(Router);
  private sessionService = inject(SessionService);

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canNavigateToPageUnderFeatureSwitch(next, state);
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canNavigateToPageUnderFeatureSwitch(next, state);
  }

  private canNavigateToPageUnderFeatureSwitch(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return new Observable(observer => {
      if (!next || !next.data || !next.data.featureSwitches) {
        this.router.navigate(['/error/404']);
        observer.next(false);
        observer.complete();
      } else {
        this.auth.isAuthenticated().subscribe(isAuthenticated => {
          if (isAuthenticated) {
            this.sessionService.loadSession().subscribe(userSession => {
              const featureSwitchEnabled = this.calculateFeatureSwitch(userSession, next);
              if (!featureSwitchEnabled) {
                this.router.navigate(['/error/404']);
              }
              observer.next(featureSwitchEnabled);
              observer.complete();
            });
          } else {
            this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
            observer.next(false);
            observer.complete();
          }
        });
      }
    });
  }

  private calculateFeatureSwitch(userSession: UserSession, next: ActivatedRouteSnapshot) {
    let featureSwitchEnabled = false;
    if (userSession && userSession.featureSwitches) {
      if (next.data.mode && next.data.mode === 'any') {
        next.data.featureSwitches.forEach(featureSwitch => featureSwitchEnabled = featureSwitchEnabled || userSession.featureSwitches[featureSwitch]);
      } else {
        featureSwitchEnabled = true;
        next.data.featureSwitches.forEach(featureSwitch => featureSwitchEnabled = featureSwitchEnabled && userSession.featureSwitches[featureSwitch]);
      }
    }
    return featureSwitchEnabled;
  }
}
